export default "__VITE_ASSET__DrDO4_yv__"